export const ClientType = {
  Individual: 0,
  Company: 1,
} as const;

export type ClientTypeType = (typeof ClientType)[keyof typeof ClientType];
